import { FieldFlowMap } from "@/hooks/useFormDependencies";
import { NewMarketFormValues } from "@/types/form";

const MARKET_TYPE = {
    chain: "chains",
} as const;

export type FieldName = keyof NewMarketFormValues;

export const SUCCESS_ERR_CODE_CHECK = -32404;

export const FIELD_FLOW_MAP: FieldFlowMap<NewMarketFormValues> = {
    partner: {
        name: "partner",
        deps: [],
    },
    partnerExternalMarketId: {
        name: "partnerExternalMarketId",
        deps: ["partner"],
    },
    region: {
        name: "region",
        deps: ["partner"],
    },
    name: {
        name: "name",
        deps: ["partner"],
    },

    legalEntity: {
        name: "legalEntity",
        deps: ["region"],
    },
    address: {
        name: "address",
        deps: ["legalEntity"],
    },

    marketType: {
        name: "marketType",
        deps: ["address"],
    },
    network: {
        name: "network",
        deps: ["marketType"],
        extraActiveCheck: (values) => values.marketType === MARKET_TYPE.chain,
    },
    storage: {
        name: "storage",
        deps: ["marketType"],
        extraActiveCheck: (values) => values.marketType !== MARKET_TYPE.chain,
    },
    parentId: {
        name: "parentId",
        deps: ["address"],
    },
};
